/** Form validation messages, chosen by Zod issue code (client and server field errors alike). */
export const validation = {
    required: "This field is required.",
    invalid: "This value is not valid.",
    tooMuch: "More than is left for this line.",
    tooShort_one: "Must be at least {{count}} character.",
    tooShort_other: "Must be at least {{count}} characters.",
    tooLong_one: "Must be at most {{count}} character.",
    tooLong_other: "Must be at most {{count}} characters.",
};
//# sourceMappingURL=validation.js.map